import { Col, Row } from "antd";
import { FocalPoint } from "@customTypes/index";

declare const SingleHeaderJustifyOptions: ["center", "start", "end", "space-around", "space-between", undefined];
export declare type SingleHeaderJustifyOption = typeof SingleHeaderJustifyOptions[number];

declare const SingleHeaderAlignOptions: ["top", "middle", "bottom", "stretch", undefined];
export declare type SingleHeaderAlignOption = typeof SingleHeaderAlignOptions[number];

interface SingleHeaderProps {
  className?: string;
  title: string | null;
  tag: string;
  description?: string;
  justify?: SingleHeaderJustifyOption;
  align?: SingleHeaderAlignOption;
  imgSrc: string;
  focalPoint?: FocalPoint;
  style?: any;
  parallax?: boolean;
  backgroundColor?: string | null;
}

const defaultProps: SingleHeaderProps = {
  title: "",
  tag: "h1",
  align: "middle",
  justify: "center",
  focalPoint: {
    left: '50%',
    top: "50%"
  },
  parallax: true,
  imgSrc: "https://via.placeholder.com/1000x250/E6EAED/CCCCCC/",
};

const ShadeHeader = ({
  className,
  tag,
  justify,
  align, title,
  description,
  imgSrc,
  focalPoint,
  style,
  backgroundColor
}: SingleHeaderProps) => {
  const css: any = ["covr-header", "covr-shade-header"];
  const HeaderTag: any = `${tag}`;
  const bgRadialGradient = backgroundColor ? `radial-gradient(circle, ${backgroundColor} 34%, rgba(2,0,36,1) 170%)` : '';
  const wrapSettings: any = {
    backgroundImage: `${bgRadialGradient}`,
    ...style,
  };
  css.push(className);

  return (
    <div className={css.join(" ")} style={wrapSettings}>
      <div className={`children`}>
        <Row justify={justify} align={align}>
          <Col>
            {title && <HeaderTag
              dangerouslySetInnerHTML={{ __html: title }}
            />}
            {description && (<p dangerouslySetInnerHTML={{
              __html: description,
            }} />)}
          </Col>
        </Row>
      </div>
      {imgSrc && focalPoint
        && <img
          style={{
            objectPosition: focalPoint.left && focalPoint.top
              ? `${focalPoint.left}% ${focalPoint.top}%`
              : `50% 50%`
          }}
          src={imgSrc}
          alt={`background`}
          loading="lazy"
        />}
    </div>
  );
};

ShadeHeader.defaultProps = defaultProps;

export default ShadeHeader;
